import axios from '../../utils/axios.js'

export const isOwnPermission = (query, options) => axios.setAxiosGetPromise('people/isOwnPermission/' + query, options)

export const faceCheck = (query) => axios.setAxiosGetPromise('face/faceCheck', query)

export const personAll = (query) => axios.setAxiosGetPromise('people/allPeople', query)

export const query = (query) => axios.setAxiosGetPromise('people', query)

export const getPerson = (query) => axios.setAxiosGetPromise('people/findOne', query)

export const getPersonByQuery = (query) => axios.setAxiosGetPromise('people/findOneByQuery', query)

export const update = (query, options) => axios.setAxiosPutPromise('people/' + query, options)

export const add = (options) => axios.setAxiosPostPromise('people', options)

// 旧版导入接口
export const importPerson = (options) => axios.setAxiosPostPromise('people/importPerson', options)

// 2.0版导入接口
export const importPeople = (options) => axios.upload('people/importPeople', options)

// 当前用户是否有正在导入的文件
export const allowedImport = (query) => axios.setAxiosGetPromise('uploadPeople/findOne', query);

// 轮询后端导入文件处理结果
export const pollImportResult = (id) => axios.setAxiosGetPromise('uploadPeople/findById/' + id);

// 下载导入失败信息文件
export const downloadFile = (query) => axios.setAxiosGetPromise('file/download', query)

export const deletePerson = (query) => axios.setAxiosDeletePromise('people/deleteOne', query)

// 批量删除用户信息
export const deletePersonBatch = (query) => axios.setAxiosDeletePromise('people/deleteBatch', query)

export const findUserName = (query) => axios.setAxiosGetPromise('people/findbyEmail', query)

// 创建导出任务
export const exportPeople = (options) => axios.setAxiosPostPromise('people/exportPeople', options)

// export const globalTest = (query) => axios.setAxiosGetPromise('people/globalTest', query)



// WEBPACK FOOTER //
// ./src/services/system/person.js